import { getRecipesPageName } from './getRecipesPageName';
import { analytics } from './segment';

type Action = 'clicked' | 'added_to_cart' | 'removed_from_cart';

export type Location = 'card' | 'rdp' | 'pdp' | 'merchandized_cart' | 'cart';

type PairingInteractionParams = {
  pairingId: number;
  pairingName?: string | null;
  actionType: Action;
  location?: Location;
  orderId?: number;
};

export const pairingInteraction = ({
  pairingId,
  pairingName,
  actionType,
  location,
  orderId,
}: PairingInteractionParams) => {
  analytics.track('pairing_interaction', {
    pairing_id: pairingId,
    pairing_name: pairingName,
    action_type: actionType,
    location,
    page_name: getRecipesPageName(),
    order_id: orderId,
  });
};
